import type { TwiageCase } from "@/App/types/twiageTypes";
import type { User } from "@/App/user/User";
import { FeatureFlag } from "@/App/types/FeatureFlag";
import { userHasFeatureForOrganization } from "@/App/user/userHasFeatureEnabled";

export const canUserAnswerLiveConsult = ({
  twiageCase,
  user,
}: {
  twiageCase: TwiageCase;
  user: User | null;
}): boolean => {
  const destinationHospitalId = twiageCase.destinationHospital?.id;
  if (!destinationHospitalId || !user) return false;

  return userHasFeatureForOrganization({
    user,
    feature: FeatureFlag.liveConsult,
    organizationId: destinationHospitalId,
  });
};
